import React from "react";

import { Chip, Grid, Typography } from "@mui/material";

import { ButtonLink } from "components/MUIExtensions/ButtonLink";
import { RETRO_PAGES } from "./RetrospectiveData";
import { useUserContext } from "contexts/UserContext";
import { ChevronRight } from "@mui/icons-material";
import { RETROSPECTIVA } from "featureSwitches/flagsList";

export const RetroCTA = () => {
  const { currentSpace } = useUserContext();
  if (RETROSPECTIVA.getValue()) {
    return (
      <ButtonLink
        fullWidth
        variant="outlined"
        to={`${RETRO_PAGES.WELCOME}?escola=${currentSpace?.id}`}
        sx={{
          background:
            "linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(90deg, #7BF1A8 0%, #00D492 50%, #46ECD5 100%)",
        }}
        endIcon={<ChevronRight sx={{ color: "common.black" }} />}
      >
        <Grid item container direction="row" sx={{ flex: 1 }}>
          <Typography
            variant="h3"
            component="span"
            width="100%"
            color="common.black"
            align="center"
            sx={{ flex: 1 }}
          >
            Ver retrospectiva 2025
            <Chip
              label="Beta"
              color="secondary"
              variant="outlined"
              sx={{ ml: 3 }}
            />
          </Typography>
        </Grid>
      </ButtonLink>
    );
  } else return null;
};
